import axios, { AxiosPromise } from 'axios'
import { AutorizacaoRetiradaAbsorventesInput } from 'view/dignidade-menstrual/model-dignidadeMenstrual'

export class DignidadeMenstrual {
  gerarAutorizacaoRetiradaAbsorventes(input: AutorizacaoRetiradaAbsorventesInput): AxiosPromise<Blob> {
    return axios.post('/api/cidadao/documento-autorizacao-retirada-absorventes', input, { responseType: 'blob' })
  }
}
